import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"
import {threePxShadowBigBlur} from "@irati/ui/src/global/elevation"

interface DropdownMenuProps {
  width?: number
}

export const DropdownMenu = styled.div<DropdownMenuProps>`
  width: ${({width}) => width || 180}px;
  margin: ${padding.tiny} 0 0;
  font-size: 14px;
  text-align: left;
  background-color: ${({theme}) => theme.colors.greys.white};
  border: none;
  padding: ${padding.tiny};
  border-radius: 4px;
  ${threePxShadowBigBlur};
  background-clip: padding-box;
`
